import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider, QueryCache } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'
import { handleApiError } from '@/lib/apiErrorHandler'

// Create query cache with global error handler
const queryCache = new QueryCache({
  onError: (error) => {
    // 401 is handled by the API client interceptor (logout + redirect)
    const apiError = error as { detail?: string; status?: number }
    if (apiError.status === 401) return
    handleApiError(apiError, 'Failed to load data')
  },
})

const queryClient = new QueryClient({
  queryCache,
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
